import React, { useEffect, useState } from "react";
import { createComponentStore } from "easy-peasy";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";
import moment from "moment";
import {
  Checkbox,
  Row,
  Col,
  List,
  Button,
  message,
  Tree,
  Collapse,
  Spin,
} from "antd";
import FormLayout from "Components/form";
import { AUTH_SUBJECTS } from "authorization";

const { Panel } = Collapse;
const useStoreStore = createComponentStore(UserStoreModel);

export default function UserGroupAuthsRoute({ id, editable, ...props }) {
  const [store, actions] = useStoreStore();

  useEffect(() => {
    actions.getGroupAuthsbyGroupId({ object: { id: id } });
  }, []);

  useEffect(() => {
    switch (store.process) {
      case ACTION_TYPES.GROUP_AUTHS_UPDATED_BY_ID:
        message.success("Kullanıcı Grubu yetkileri güncellendi.");
        actions.getGroupAuthsbyGroupId({ object: { id: id } });
      default:
        break;
    }
  }, [store.process]);

  const renderCheckBox = (auth, m) => {
    let item =
      store.groupAuths &&
      store.groupAuths.length > 0 &&
      store.groupAuths.find((f) => f.auth.name == m.name);
    if (!item) return;

    return (
      <Checkbox
        defaultChecked={item[auth.value]}
        onChange={(value) => {
          let clone = { ...item };
          clone[auth.value] = value.target.checked;
          actions.updateGroupAuthData(clone);
        }}
      >
        {auth.label}
      </Checkbox>
    );
  };

  const loop = (data) => {
    return (
      <Collapse style={{ marginTop: 8 }}>
        {data.map((m) => (
          <Panel header={m.name}>
            <Row style={{ width: "100%" }}>
              {!m.onlyNavigation &&
                [
                  { label: "Hepsi", value: "authAll" },
                  { label: "Menü", value: "authMenu" },
                  { label: "Yeni Kayıt", value: "authNewRecord" },
                  { label: "Okuma", value: "authRead" },
                  { label: "Yazma", value: "authWrite" },
                  { label: "Silme", value: "authDelete" },
                  { label: "Arşiv Okuma", value: "authReadArhive" },
                  { label: "Arşiv Kurtarma", value: "authReturnArchive" },
                ].map((auth, index) => {
                  if (
                    m.auth_actions &&
                    !m.auth_actions.includes(auth.value.substr(4))
                  )
                    return;

                  return (
                    <Col xs={24} key={index}>
                      {renderCheckBox(auth, m)}
                    </Col>
                  );
                })}
            </Row>
            {m.children && loop(m.children)}
          </Panel>
        ))}
      </Collapse>
    );
  };

  return (
    <FormLayout>
      <Col xs={24}>
        <Row>
          <Col xs={24}>
            <Spin
              spinning={
                store.process === ACTION_TYPES.FETCHING_GROUP_AUTHS_BY_ID
              }
            >
              {loop(AUTH_SUBJECTS)}
            </Spin>
            {/*<List
              loading={

              }
              dataSource={store.groupAuths}
              bordered
              renderItem={(item) => {
                return (
                  <List.Item
                    key={item.id}
                    style={{ flexDirection: "column", alignItems: "start" }}
                  >
                    <b>{item.auth?.name}</b>
                    <Row style={{ width: "100%" }}>
                      {[
                        { label: "Hepsi", value: "authAll" },
                        { label: "Menü", value: "authMenu" },
                        { label: "Yeni Kayıt", value: "authNewRecord" },
                        { label: "Okuma", value: "authRead" },
                        { label: "Yazma", value: "authWrite" },
                        { label: "Silme", value: "authDelete" },
                        { label: "Arşiv Okuma", value: "authReadArhive" },
                        { label: "Arşiv Kurtarma", value: "authReturnArchive" },
                      ].map((auth, index) => (
                        <Col xs={24} sm={12} md={4} lg={4} key={index}>
                          <Checkbox
                            defaultChecked={item[auth.value]}
                            onChange={(value) => {
                              let clone = { ...item };
                              clone[auth.value] = value.target.checked;
                              actions.updateGroupAuthData(clone);
                            }}
                          >
                            {auth.label}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </List.Item>
                );
              }}
            />
            */}
          </Col>
        </Row>
        <Row
          justify="space-between"
          style={{
            borderTop: "1px dashed rgb(166, 157, 152)",
            position: "sticky",
            bottom: 0,
            width: "100%",
            padding: "16px 0",
            backgroundColor: "#f2f2f2",
          }}
        >
          <Col xs={24}>
            <Button
              type="primary"
              loading={
                store.process === ACTION_TYPES.UPDATING_GROUP_AUTHS_BY_ID
              }
              onClick={() =>
                actions.updateGroupAuthbyGroupId({
                  object: { id: id },
                  body: store.groupAuths,
                })
              }
            >
              Kaydet
            </Button>
          </Col>
        </Row>
      </Col>
    </FormLayout>
  );
}
